// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ruleGroup {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  border-color: #8081a2;
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  background: rgba(0, 75, 183, 0.2);
}
.ruleGroup .ruleGroup-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.ruleGroup .ruleGroup-body:empty {
  display: none;
}
.ruleGroup .ruleGroup-header,
.ruleGroup .rule {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.ruleGroup .rule .rule-value .rule-value-list-item:not(:first-of-type) {
  margin-left: 0.5rem;
}

[data-inlinecombinators=disabled] .dndOver.rule, [data-inlinecombinators=disabled] .dndOver.ruleGroup-header {
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  border-bottom-color: rebeccapurple;
  padding-bottom: 0.5rem;
}
[data-inlinecombinators=disabled] .dndOver.rule.dndCopy, [data-inlinecombinators=disabled] .dndOver.ruleGroup-header.dndCopy {
  border-bottom-color: #669933;
}

[data-inlinecombinators=enabled] .dndOver.rule:last-child, [data-inlinecombinators=enabled] .dndOver.ruleGroup-header, [data-inlinecombinators=enabled] .dndOver.rule + .betweenRules, [data-inlinecombinators=enabled] .dndOver.betweenRules {
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  border-bottom-color: rebeccapurple;
  padding-bottom: 0.5rem;
}
[data-inlinecombinators=enabled] .dndOver.rule:last-child.dndCopy, [data-inlinecombinators=enabled] .dndOver.ruleGroup-header.dndCopy, [data-inlinecombinators=enabled] .dndOver.rule + .betweenRules.dndCopy, [data-inlinecombinators=enabled] .dndOver.betweenRules.dndCopy {
  border-bottom-color: #669933;
}

.ruleGroup.dndDragging,
.rule.dndDragging {
  opacity: 0.5;
}
.ruleGroup .queryBuilder-dragHandle,
.rule .queryBuilder-dragHandle {
  cursor: move;
}

[data-dnd=disabled] .queryBuilder-dragHandle {
  display: none;
}

.queryBuilder-branches .ruleGroup-body {
  margin-left: calc(2 * 0.5rem);
}
.queryBuilder-branches .rule,
.queryBuilder-branches .ruleGroup .ruleGroup {
  position: relative;
}
.queryBuilder-branches .rule::before, .queryBuilder-branches .rule::after,
.queryBuilder-branches .ruleGroup .ruleGroup::before,
.queryBuilder-branches .ruleGroup .ruleGroup::after {
  content: "";
  width: 0.5rem;
  left: calc(-0.5rem - 1px);
  border-color: #8081a2;
  border-style: solid;
  border-radius: 0;
  position: absolute;
}
.queryBuilder-branches .rule::before,
.queryBuilder-branches .ruleGroup .ruleGroup::before {
  top: -0.5rem;
  height: calc(50% + 0.5rem);
  border-width: 0 0 1px 1px;
}
.queryBuilder-branches .rule:last-child::before,
.queryBuilder-branches .ruleGroup .ruleGroup:last-child::before {
  border-bottom-left-radius: 4px;
}
.queryBuilder-branches .rule::after,
.queryBuilder-branches .ruleGroup .ruleGroup::after {
  top: 50%;
  height: 50%;
  border-width: 0 0 0 1px;
}
.queryBuilder-branches .rule:last-child::after,
.queryBuilder-branches .ruleGroup .ruleGroup:last-child::after {
  display: none;
}
.queryBuilder-branches .ruleGroup .ruleGroup::before, .queryBuilder-branches .ruleGroup .ruleGroup::after {
  left: calc(calc(-0.5rem - 1px) - 1px);
}
.queryBuilder-branches .ruleGroup .ruleGroup::before {
  top: calc(-0.5rem - 1px);
  height: calc(50% + 0.5rem + 1px);
}
.queryBuilder-branches .ruleGroup .ruleGroup::after {
  height: calc(50% + 1px);
}
.queryBuilder-branches .betweenRules {
  position: relative;
}
.queryBuilder-branches .betweenRules::before {
  content: "";
  width: 0.5rem;
  left: calc(-0.5rem - 1px);
  border-color: #8081a2;
  border-style: solid;
  border-radius: 0;
  position: absolute;
  top: -0.5rem;
  height: calc(100% + 0.5rem);
  border-width: 0 0 0 1px;
}

/*# sourceMappingURL=query-builder.css.map */
`, "",{"version":3,"sources":["webpack://./node_modules/react-querybuilder/src/query-builder.scss","webpack://./node_modules/react-querybuilder/dist/query-builder.css"],"names":[],"mappings":"AAsBA;EACE,aAAA;EACA,sBAAA;EACA,WAxBY;EAyBZ,eAzBY;EA0BZ,qBAxBiB;EAyBjB,mBAxBiB;EAyBjB,kBAxBkB;EAyBlB,iBAxBiB;EAyBjB,iCA7BqB;ACQvB;ADuBE;EACE,aAAA;EACA,sBAAA;EACA,WAnCU;ACcd;ADuBI;EACE,aAAA;ACrBN;ADyBE;;EAEE,aAAA;EACA,WA7CU;EA8CV,mBAAA;ACvBJ;AD4BM;EACE,mBApDM;AC0Bd;;ADqCI;EAEE,wBAtD8B;EAuD9B,2BAxD8B;EAyD9B,kCA3D8B;EA4D9B,sBApEQ;ACiCd;ADqCM;EACE,4BA9DiC;AC2BzC;;AD0CI;EAIE,wBAvE8B;EAwE9B,2BAzE8B;EA0E9B,kCA5E8B;EA6E9B,sBArFQ;AC2Cd;AD4CM;EACE,4BA/EiC;ACqCzC;;ADmDE;;EACE,YAAA;AC/CJ;ADkDE;;EACE,YAAA;AC/CJ;;ADoDA;EACE,aAAA;ACjDF;;ADyDE;EACE,6BAAA;ACtDJ;ADyDE;;EAEE,kBAAA;ACvDJ;ADyDI;;;EAEE,WAAA;EACA,aA/HQ;EAgIR,yBAAA;EACA,qBA/Ha;EAgIb,mBA/Ha;EAgIb,gBAAA;EACA,kBAAA;ACtDN;ADyDI;;EACE,YAAA;EACA,0BAAA;EACA,yBAAA;ACtDN;ADyDI;;EACE,8BA1Ic;ACoFpB;ADyDI;;EACE,QAAA;EACA,WAAA;EACA,uBAAA;ACtDN;ADyDI;;EACE,aAAA;ACtDN;AD2DI;EAEE,qCAAA;AC1DN;AD6DI;EACE,wBAAA;EACA,gCAAA;AC3DN;AD8DI;EACE,uBAAA;AC5DN;ADgEE;EACE,kBAAA;AC9DJ;ADgEI;EACE,WAAA;EACA,aAjLQ;EAkLR,yBAAA;EACA,qBAjLa;EAkLb,mBAjLa;EAkLb,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,uBAAA;AC9DN;;AAEA,4CAA4C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
